import { c as _c } from "react/compiler-runtime";
import LockIcon from '@mui/icons-material/Lock';
import useColorByStatus from './useColorByStatus';
import TYPES from '../constants/activityType';
function getProjectStatusLabel(status, isCurrent, isLocked, translations) {
  const defaultString = translations.toComplete;
  if (isLocked) {
    return defaultString;
  }
  const labelByStatus = {
    'in progress': isCurrent ? translations.inProgress : defaultString,
    'not started': translations.toComplete,
    retry: translations.toRework,
    'ready for review': translations.presentationToBeScheduled,
    'awaiting review': translations.presentationScheduled,
    passed: translations.completed
  };
  return labelByStatus[status] || defaultString;
}
function getDisplayStatus(learningActivityStatus, isCurrent) {
  let displayStatus = learningActivityStatus;
  if (learningActivityStatus === 'in progress' && !isCurrent) {
    displayStatus = 'not started';
  }
  if (learningActivityStatus === 'ready for review') {
    displayStatus = 'awaiting review';
  }
  return displayStatus;
}
const useProjectStatus = t0 => {
  const $ = _c(20);
  const {
    learningActivityStatus,
    progression,
    number,
    isCurrent: t1,
    isLocked: t2,
    translations: t3
  } = t0;
  const isCurrent = t1 === undefined ? false : t1;
  const isLocked = t2 === undefined ? false : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? {
      inProgress: "Project in progress",
      toComplete: "Project to complete",
      toRework: "Project to rework",
      presentationToBeScheduled: "Project presentation to schedule",
      presentationScheduled: "Project presentation scheduled",
      completed: "Project completed"
    } : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const translations = t4;
  const hasProgression = typeof progression === "number";
  let t5;
  if ($[2] !== isCurrent || $[3] !== learningActivityStatus) {
    t5 = getDisplayStatus(learningActivityStatus, isCurrent);
    $[2] = isCurrent;
    $[3] = learningActivityStatus;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const displayStatus = t5;
  const hideProgression = !hasProgression || isLocked || learningActivityStatus === "passed";
  const color = useColorByStatus(isLocked ? "not started" : displayStatus);
  const t6 = number && (learningActivityStatus === "not started" || !isCurrent && learningActivityStatus === "in progress");
  let statusComponentProps;
  if ($[5] !== displayStatus || $[6] !== isLocked || $[7] !== number || $[8] !== t6) {
    statusComponentProps = {
      number,
      status: displayStatus,
      isIconHidden: t6,
      activityType: TYPES.PROJECT
    };
    if (isLocked) {
      statusComponentProps.forcedIcon = LockIcon;
      statusComponentProps.isIconHidden = false;
    }
    $[5] = displayStatus;
    $[6] = isLocked;
    $[7] = number;
    $[8] = t6;
    $[9] = statusComponentProps;
  } else {
    statusComponentProps = $[9];
  }
  let t7;
  if ($[10] !== isCurrent || $[11] !== isLocked || $[12] !== learningActivityStatus || $[13] !== translations) {
    t7 = getProjectStatusLabel(learningActivityStatus, isCurrent, isLocked, translations);
    $[10] = isCurrent;
    $[11] = isLocked;
    $[12] = learningActivityStatus;
    $[13] = translations;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = hasProgression && !hideProgression;
  let t9;
  if ($[15] !== color || $[16] !== statusComponentProps || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      color,
      statusLabel: t7,
      statusComponentProps,
      shouldShowProgression: t8
    };
    $[15] = color;
    $[16] = statusComponentProps;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default useProjectStatus;